import React, { type ReactNode } from 'react';

import { type SectionGap, type SectionStretch } from '../../../../types';

import { LayoutWrapper, SectionWrapper } from './styles';

export interface LayoutProps {
    children: ReactNode;
}

interface SectionProps {
    children: ReactNode;
    gap?: SectionGap;
    stretch?: SectionStretch;
    alignEnd?: boolean;
}

export function Layout({ children }: LayoutProps) {
    return <LayoutWrapper>{children}</LayoutWrapper>;
}

function Section({ children, gap, stretch, alignEnd = false }: SectionProps) {
    return (
        <SectionWrapper $gap={gap} $stretch={stretch} $alignEnd={alignEnd}>
            {children}
        </SectionWrapper>
    );
}

Layout.Section = Section;
